import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import useStore from "store/hook";
import SoftTypography from "components/SoftTypography";
import SoftBox from "components/SoftBox";
import api from "store/api/api";
import { DialogActions, DialogTitle, TextField } from "@mui/material";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import { toast } from "react-toastify";
import CircularLoader from "./Loader";

export default function AddSiteRepresentative({
  setAddInspectionData,
  setInspectionDetails,
}) {
  const { store, setDialogue } = useStore();
  const [loading, setLoading] = React.useState(false);

  const [data, setData] = React.useState({
    name: "",
    companyName: "",
  });

  const { isOpen = false, action, name, companyName, index, isEdit } =
    store?.app?.dialogs?.addSiteRepresentative || {};

  React.useEffect(() => {
      if(action == "editSiteRepresentative" || action == "editSiteRepresentativeInAddInspection"){
        setData({name: name, companyName:companyName})
      }
  }, [isOpen]);

  const handleClose = () => {
    setDialogue({
      type: "addSiteRepresentative",
      isOpen: false,
    });
  };

  const handleAdd = () => {
    if (!data?.name) {
      toast.error("Please enter the name of the site representative");
    }else {
      if (action == "updateinspection") {
        setInspectionDetails((prev) => ({
          ...prev, 
          site_representative: [...prev.site_representative, data],
        }))
      } else {
        setAddInspectionData((prev) => ({
          ...prev,
          site_representative: [...prev.site_representative, data],
        }));
      }

      setData({
        name: "",
        companyName: "",
      });
      handleClose();
    }
  };

  const handleUpdate = () => {
    if (!data?.name) {
      toast.error("Please Enter the name of the Site Representative");
    }else {
      if (action == "editSiteRepresentative") {
        setInspectionDetails((prev) => ({...prev, site_representative:prev.site_representative.map((item, i) => i == index? data: item)}))
      }

      else if(action == "editSiteRepresentativeInAddInspection"){
        setAddInspectionData((prev) => ({...prev, site_representative:prev.site_representative.map((item, i) => i == index? data: item)}))
      }

      setData({
        name: "",
        companyName: "",
      });
      handleClose();
    }
  }

  

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="add-link-dialog-title"
      aria-describedby="add-link-dialog-description"
      sx={{
        "& .MuiDialog-paper": {
          m:0,
          p:0,
          borderRadius: "12px",
          width: "400px",
          
        },
      }}
    >
      <DialogTitle
        style={{
          background: "#02255B",
          textAlign: "center",
          color: "#fff",
        }}
        id="add-link-dialog-title"
      >
        <SoftTypography
          style={{
            fontSize: "18px",
          }}
          variant="h5"
          fontWeight="bold"
        >
          Add Site Representative
        </SoftTypography>
      </DialogTitle>

      <DialogContent>
        <SoftTypography textAlign="center" sx={{ fontSize: "12px", py: "9px" }}>
          Provide the name and company name of the site representative for the
          inspector for any inquiries or information.
        </SoftTypography>

        <SoftBox display="flex" flexDirection="column" gap={3}>
          <SoftInput
            fullWidth
            variant="outlined"
            placeholder="Name"
            value={data?.name}
            onChange={(e) =>
              setData((prev) => ({ ...prev, name: e.target.value }))
            }
            name="contactName"
            color="#02255B !important"
            required
            sx={{
              padding: "12px 12px",
              "& .MuiInputBase-input::placeholder": {
                color: "#747474 !important",
                fontSize: "14px",
                opacity: 1,
              },
            }}
          />

          <SoftBox
            display="flex"
            alignItems="center"
            width="100%"
            borderRadius="10px"
            border="0.5px solid #02255B"
          >
            <SoftBox
              color="white"
              display="flex"
              alignItems="center"
              pl={1}
              sx={{
                backgroundColor: "#02255B",
                borderTopLeftRadius: "8px",
                borderBottomLeftRadius: "8px",
                width: "80px",
                height: "50px",
                fontSize: "12px",
                fontWeight: "normal",
                whiteSpace: "nowrap",
              }}
            >
              Company <br></br>Name
            </SoftBox>

            <TextField
              fullWidth
              variant="outlined"
              placeholder="Enter Company Name"
              value={data?.companyName}
              onChange={(e) =>
                setData((prev) => ({ ...prev, companyName: e.target.value }))
              }
              name="currentCompanyName"
              InputProps={{
                sx: {
                  borderRadius: "0px 8px 8px 0px",
                  backgroundColor: "#FFFFFF",
                  border: "none",
                  "& .MuiInputBase-input::placeholder": {
                    color: "#747474 !important",
                    fontSize: "14px",
                    opacity: 1,
                  },
                  "&.MuiOutlinedInput-root": {
                    "& fieldset": {
                      border: "none !important",
                    },
                    "&:hover fieldset": {
                      border: "none !important",
                    },
                    "&.Mui-focused fieldset": {
                      border: "none !important",
                    },
                  },
                  boxShadow: "none",
                  paddingLeft: "12px",
                },
              }}
              sx={{
                flex: 1,
                minWidth: "200px",
              }}
            />

            <SoftBox
              sx={{
                pr: "6px",
                fontSize: "12px",
                color: "#777",
                fontWeight: "500",
                whiteSpace: "nowrap",
                color: "#02255B",
                display:{
                  xs:"none",
                  sm:"block"
                }
              }}
            >
              Optional
            </SoftBox>
          </SoftBox>
        </SoftBox>
      </DialogContent>

      <DialogActions
        sx={{ justifyContent: "center", flexDirection: "column", gap: 2 }}
      >
        <SoftButton
          variant="gradient"
          color="info"
          sx={{
            width: "100px",
            padding: "5px",
            background: "#02255B",
            fontSize: "14px",
            fontWeight: "bold",
          }}
         onClick={isEdit ? handleUpdate : handleAdd}
        >
        {isEdit ? "Update" : "Add"} 
        </SoftButton>
        <SoftTypography
          fontSize="16px"
          fontWeight="bold"
          color="primary"
          sx={{ cursor: "pointer" }}
          onClick={handleClose}
        >
          Cancel
        </SoftTypography>
      </DialogActions>
    </Dialog>
  );
}
